import phoneIcon from '../assets/phone1-icon.png';
import mailIcon from '../assets/mail1-icon.png';
import locationIcon from '../assets/location-icon.png';
import gridBg from '../assets/grid-bg1.webp';
import contactStrip from '../assets/contact-strip.webp'; // Adjust the path if needed
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import ClockIcon from "../assets/clock.png";
import LightBulb from "../assets/light.svg";
import ConciergeImage from "../assets/concierge.png";
import { Helmet } from "react-helmet-async";
import { useNavigate } from 'react-router-dom';
import { useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import contactGrid from '../assets/contact-grid.svg';

export default function ContactSection() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
  const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");


  const [getuserCaptcha, setgetUserCaptcha] = useState("");

  // NOTE: removed duplicated fetch/useEffect that attempted to set token before it was declared.
  // The newsletter captcha flow uses fetchCaptcha()/sessionId/token/captchaText defined later.

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API

  /* ------------------------------------------------------------------- API fetch */


  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");

    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

  /* -- reload button click ------------------------------------------------------- */

  const handleSubscribe = async (e) => {
    e?.preventDefault?.();

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!submail) {
      toast("Please enter an email address");
      return;
    }

    if (!emailRegex.test(submail)) {
      toast("Please enter a valid email address");
      return;
    }

    if (!newsletterUserCaptcha) {
      toast("Please enter the captcha");
      return;
    }

    try {
      const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
        },
        body: JSON.stringify({
          session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
          captcha: newsletterUserCaptcha, // use newsletter captcha input
          email: submail,
          type: "Mawalog",
        }),
      });

      const result = await res.json();

      // On success clear inputs and reload captcha
      if (res.ok) {
        setSubmail("");
        setNewsletterUserCaptcha("");
        fetchNewsletterCaptcha();
      }

      toast(result.message || "Subscription response received");
    } catch (err) {
      console.error("Newsletter subscribe error:", err);
      toast("Subscription failed. Please try again.");
    }
  };

  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
  const [isCompanyOpen, setIsCompanyOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleServicesDropdown = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const toggleIndustriesDropdown = () => {
    setIsIndustriesOpen(!isIndustriesOpen);
  };

  const toggleCompanyDropdown = () => {
    setIsCompanyOpen(!isCompanyOpen);
  };
  const [onStates, setOnStates] = useState([true, true, false, false]);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnStates((prev) =>
        prev.map((state, index) => (index % 2 === 0 ? !state : state))
      );
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const flickerVariants = {
    animate: {
      opacity: [1, 0.5, 1],
      transition: {
        repeat: Infinity,
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  };

  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#contact-section") {
      const section = document.getElementById("contact-section");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);







  const [dataa, setDataa] = useState("");
  const [sessionidd, setSessionidd] = useState("");
  const [tokenn, setTokenn] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setDataa(json.data.captcha_code);
        setSessionidd(json.data.session_id);
        setTokenn(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(dataa, 10, 22);
    }
  }, [dataa]);
  // const handleChange = (e) => {
  //   setEmail(e.target.value);
  // };

  const getcanvasRef = useRef(null);


  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setDataa(json.data.captcha_code);
        setSessionidd(json.data.session_id);
        setTokenn(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!dataa) return; // nothing to paint yet
    const canvas = getcanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }

    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = dataa.toString().split("");

    /* ========= characters (extra-uneven, extra-distorted) */
    const fonts = [
      "Arial",
      "Verdana",
      "Georgia",
      "Courier New",
      "Times New Roman",
    ];

    chars.forEach((ch, i) => {
      // more dramatic randomness
      const angle = (Math.random() - 0.5) * 1.4; // ±40 °
      const x = 6 + i * 14 + (Math.random() * 8 - 4);
      const y = 20 + (Math.random() * 10 - 5);

      ctx.save();
      ctx.translate(x, y);

      /* skew / stretch */
      ctx.transform(
        1 + (Math.random() * 0.2 - 0.1), // scale-X
        Math.random() * 0.35 - 0.175, // skew-Y
        Math.random() * 0.35 - 0.175, // skew-X
        1 + (Math.random() * 0.2 - 0.1), // scale-Y
        0,
        0
      );

      ctx.rotate(angle);

      /* random font & size */
      ctx.font = `bold ${18 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]
        }`;
      ctx.fillStyle = "#0A3A72";
      ctx.fillText(ch, 0, 0);

      ctx.restore();
    });

    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [dataa]);

  /* -- reload button click ------------------------------------------------------- */
  const gethandleReload = () => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => {
        console.log(response);
        return response.json(); // ✅ must return this
      })
      .then((json) => {
        console.log("Reloaded captcha:", json.data.captcha_code); // optional debug
        setDataa(json.data.captcha_code);
        setSessionidd(json.data.session_id);
        setTokenn(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  };





  const gethandleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        "https://api.app.mawalog.com/v1.2/website",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": tokenn,
          },
          body: JSON.stringify({
            session_id: sessionidd,
            captcha: getuserCaptcha,
            name: formData.name,
            email: formData.email,
            contact_number: formData.phone,
            message: formData.message,
            company_name: formData.company,
          }),
        }
      );

      const result = await response.json();
      console.log("Response:", getuserCaptcha, result);

      // Clear form fields
      // Clear form fields
      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
        company: "",
        captcha: "",
      });

      // Clear captcha input
      setgetUserCaptcha("");

      // Reload captcha canvas
      gethandleReload();


      // Clear captcha
      setgetUserCaptcha("");

      toast(result.message);
    } catch (error) {
      console.error("Error sending request:", error);
    }
  };








  // ---------------------------------------------------------------------------------------------------------

  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const [captchaText, setCaptchaText] = useState("");
  const [userCaptcha, setUserCaptcha] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [token, setToken] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const captchaRef = useRef(null);
  const [loadingCaptcha, setLoadingCaptcha] = useState(false);

  const isMobile = screenWidth <= 768;

  /* ---------- Fetch CAPTCHA from API ---------- */
  const fetchCaptcha = async () => {
    try {
      setLoadingCaptcha(true);
      const res = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await res.json();
      setCaptchaText(json.data.captcha_code || "ERROR");
      setSessionId(json.data.session_id);
      setToken(json.data.token);
    } catch (err) {
      console.error("Error fetching captcha:", err);
    } finally {
      setLoadingCaptcha(false);
    }
  };


  /* ---------- Load CAPTCHA on mount ---------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);

  /* ---------- Draw CAPTCHA whenever text changes ---------- */
  useEffect(() => {
    if (!captchaText) return;
    const canvas = captchaRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, W, H);

    // Draw random noise curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.3})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // Draw captcha characters (distorted)
    const chars = captchaText.toString().split("");
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 10 + i * 14 + (Math.random() * 5 - 2);
      const y = 25 + (Math.random() * 5 - 2);

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${18 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]
        }`;
      ctx.fillStyle = "#0A3A72";
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // Add small dots
    for (let i = 0; i < 40; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [captchaText]);

  /* ---------- Reload CAPTCHA ---------- */

  // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);

  return (
    <>


      <Helmet>
        <title>Contact LENTERA | Get Expert Support & Connect with Us.
        </title>
        <meta name="description" content="Reach out to LENTERA for questions, feedback, or personalized business guidance via phone, email, or our contact form. Our expert team provides fast, friendly, and reliable support to help your business succeed." />
        <meta name="keywords" content="LENTERA contact information, business support services, tech consultancy contact.

"/>
      </Helmet>




      {/* Top Banner Section */}
      <section
        className="pt-20 pb-36 bg-fullcover bg- text-white "
        style={{ backgroundImage: `url(${gridBg})` }}
      >
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">We’d love to help you</h2>
          <p className="text-lg text-gray-100 max-w-2xl mx-auto">
            Please feel free to get in touch using the form below. We'd love to
            hear your thoughts & answer any questions you may have!
          </p>
        </div>
      </section>

      {/* Light Blue Section Wrap with Cards Inside */}
      <section className="relative z-6 -mt-24">
        <div className="max-w-7xl mx-auto px-4">

          <div className="relative z-10 max-w-6xl mx-auto px-4">
            <div className="bg-white rounded-2xl shadow-2xl px-6 py-10">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Card 1 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img src={phoneIcon} alt="Phone Icon" className="w-10 h-10 mb-4" />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">Make a call</h3>
                  <p className="text-[#4e5a6a] mb-4">Let’s talk with our experts</p>
                  <a
                    href="tel:+914448563345"
                    className="text-green-700 font-bold text-lg hover:underline"
                  >
                    +91-44-4856-3345
                  </a>
                </div>

                {/* Card 2 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img src={mailIcon} alt="Mail Icon" className="w-10 h-10 mb-4" />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">Send a mail</h3>
                  <p className="text-[#4e5a6a] mb-4">Don't hesitate to mail</p>
                  <div className="space-x-2">

                    <a
                      href="mailto:info@lenteratech.com"
                      className="bg-white text-blue-900 px-7 py-2 rounded-full text-sm font-medium hover:underline"
                    >
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                {/* Card 3 */}
                <div className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-xl p-6 shadow-md">
                  <img src={locationIcon} alt="Location Icon" className="w-10 h-10 mb-4" />
                  <h3 className="text-lg font-semibold text-[#131519] mb-2">Address</h3>
                  <a
                    href="https://www.google.com/maps/place/G1,+Plot+No,+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-700 font-medium text-sm hover:underline block"
                  >
                    G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South, Madipakkam, Chennai, Tamil Nadu 600091.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      {/* Extra Bottom Padding */}
      <div className="pb-20"></div>







      <div>
        {/* Your entire Contact page content including the section below */}
        <section id="contact-section" className="bg-[#f8f9fb] w-full px-6 py-20">
          <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row gap-16 items-start">

            {/* LEFT SIDE */}
            <div className="w-full md:w-[55%] relative px-4 sm:px-6 lg:px-0">
              {/* Section Header */}
              <p className="text-green-600 font-semibold mb-4">Let us help</p>

              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1f1f1f] mb-4 leading-tight">
                Get in touch with us
              </h2>

              <p className="text-base sm:text-lg text-gray-700 mb-10 max-w-md">
                We’re here to help—reach out anytime with questions, feedback, or just to say hello!
              </p>

              {/* ICON + GRID CONTAINER */}
              <div className="relative w-full flex justify-center md:justify-start">
                <div className="relative w-[260px] sm:w-[300px] md:w-[360px] h-[240px]">
                  {/* Clock Icon - top left */}
                  <motion.img
                    src={ClockIcon}
                    alt="Clock"
                    className="absolute top-[0px] left-[-20px] w-10 sm:w-[60px] md:w-[80px]"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
                  />

                  {/* Lightbulb Icon - top right */}
                  <motion.img
                    src={LightBulb}
                    alt="Light"
                    className="absolute top-0 right-[-36px] w-[50px] sm:w-[70px] md:w-[120px]"
                    variants={flickerVariants}
                    animate="animate"
                  />

                  {/* Grid Background + Icons */}
                  <div className="relative w-full h-full rounded-xl overflow-hidden">
                    <img
                      src={contactGrid}
                      alt="Contact Grid"
                      className="w-full h-full object-contain"
                    />

                    <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-px z-10">
                      {[].map((icon, index) => (
                        <motion.div
                          key={index}
                          className="flex items-center justify-center border border-[#D2DBE8] bg-white"
                          animate={{
                            filter: onStates[index] ? "brightness(1)" : "brightness(0.5)",
                            opacity: onStates[index] ? 1 : 0.6,
                          }}
                          transition={{ duration: 0.3 }}
                        >
                          <img
                            src={icon}
                            alt={`icon-${index}`}
                            className="w-[36px] sm:w-[44px] h-auto"
                          />
                        </motion.div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative flex justify-center md:justify-start top-[-10px] right-[-50px] mt-[-50px] sm:mt-[-50px] md:mt-[-10px] lg:mt-[-50px]">
                <img
                  src={ConciergeImage}
                  alt="Concierge"
                  className="w-[260px] sm:w-[360px] md:w-[440px] lg:w-[500px] h-auto ml-[-20px] sm:ml-[-40px] md:ml-[-50px] lg:ml-[-60px]"
                />
              </div>


              {/* Quote */}
              <blockquote className="mt-8 sm:mt-10 text-base sm:text-lg text-[#2d2d2d] max-w-[600px]">
                <span className="text-2xl align-top leading-none">“</span>
                We’ll assign a concierge to learn your setup and guide you on how Lentera can meet
                your business needs through one-on-one sessions. Think of us as your own personal
                business consultants.
                <span className="text-2xl align-bottom leading-none">”</span>
              </blockquote>
            </div>


            {/* RIGHT SIDE FORM */}
            <div className="w-full md:w-[45%] bg-white rounded-xl shadow-xl p-8 sm:p-10">
              <h3 className="text-xl font-semibold text-[#1f1f1f] mb-6">
                Submit your info and our concierge will be in touch
              </h3>
              <form className="space-y-4">
                {["Your name*", "Company name*", "Email*", "Phone number*"].map(
                  (placeholder, i) => {
                    const fieldNames = ["name", "company", "email", "phone"];
                    return (
                      <input
                        key={i}
                        type="text"
                        name={fieldNames[i]}
                        placeholder={placeholder}
                        value={formData[fieldNames[i]]}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            [fieldNames[i]]: e.target.value,
                          })
                        }
                        className="w-full p-3 border-2 border-[#EBEBEB] rounded-xl focus:border-green-600 focus:outline-none transition"
                      />
                    );
                  }
                )}

                <textarea
                  placeholder="Message (Optional)"
                  className="w-full p-4 border-2 border-[#EBEBEB] rounded-xl h-32 resize-none focus:border-green-600 focus:outline-none transition"
                  value={formData.message}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      message: e.target.value,
                    })
                  }
                />
                <p className="text-sm text-gray-500">
                  By submitting this form, you agree to the processing of
                  personal data according to our{" "}
                  <a href="https://lenteratech.com/privacy-policy/" className="text-blue-600 underline">
                    Privacy Policy
                  </a>
                  .
                </p>
                <>
                  <>
                    <>
                      <style>{`
    .captcha-containerr {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 10px;
      margin: 20px 0;
      flex-wrap: nowrap;
    }

    .captcha-boxx {
      width: 140px !important;
      height: 45px !important;
      background-color: #fff !important;
      border: 1px solid #E0E0E0 !important;
      border-radius: 6px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      overflow: hidden !important;
    }

    .captcha-inputt {
      flex: 1 !important;
      height: 45px !important;
      border: 1px solid #E0E0E0 !important;
      border-radius: 8px !important;
      padding: 0 14px !important;
      outline: none !important;
      font-size: 16px !important;
      color: #333 !important;
      background: #fff !important;
      transition: border-color 0.2s ease !important;
    }

    .captcha-inputt:focus {
      border-color: #07862B !important;
    }

    .refresh-btn {
      width: 42px !important;
      height: 42px !important;
      background-color: #07862B !important;
      border: none !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      cursor: pointer !important;
      transition: background 0.3s ease !important;
    }

    .refresh-btn:hover {
      background-color: #056b23 !important;
    }

    .continue-btn {
      width: 100% !important;
      background-color: #07862B !important;
      color: #fff !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      border: none !important;
      border-radius: 50px !important;
      padding: 14px 0 !important;
      margin-top: 15px !important;
      cursor: pointer !important;
      transition: background 0.3s ease !important;
    }

    .continue-btn:hover {
      background-color: #056b23 !important;
    }

    @media (max-width: 768px) {
      .captcha-containerr {
        flex-wrap: wrap !important;
      }
      .captcha-boxx,
      .captcha-inputt {
        width: 100% !important;
      }
    }
  `}</style>

                      {/* CAPTCHA + CONTINUE SECTION */}
                      <div className="captcha-containerr">
                        <div className="captcha-boxx">
                          <canvas ref={getcanvasRef} id="contactCaptchaCanvas" width={120} height={40} />
                        </div>

                        <button type="button" onClick={gethandleReload} className="refresh-btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="22"
                            height="22"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="23 4 23 10 17 10"></polyline>
                            <polyline points="1 20 1 14 7 14"></polyline>
                            <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                          </svg>
                        </button>

                        {/* <input
                          type="text"
                          placeholder="Enter captcha"
                          value={getuserCaptcha}
                          onChange={(e) => setgetUserCaptcha(e.target.value)}
                          className="captcha-inputt"
                        /> */}

                        <input
                          type="text"
                          placeholder="Enter captcha"
                          value={getuserCaptcha}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d{0,3}$/.test(value)) {
                              setgetUserCaptcha(value);
                            }
                          }}
                          className="captcha-inputt"
                        />

                      </div>

                      <button
                        className="continue-btn"
                        onClick={(e) => gethandleSubmit(e)}
                      >
                        Submit
                      </button>
                    </>



                  </>

                </>
                {/* <button
          type="submit"
          className="w-full bg-green-700 hover:bg-green-800 text-white py-4 rounded-full font-semibold"
        >
          SUBMIT
        </button> */}
              </form>
            </div>
          </div>
        </section>
      </div>


      <div className="w-full bg-white font-poppins py-16 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between">

        {/* Left Side */}
        <div className="md:w-1/2 space-y-6">
          <div className="inline-block px-4 weight-500 size-16px py-2 bg-green-100 text-green-700 text-sm font-semibold rounded-full">
            Need assistance?
          </div>

          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            We're Here to Help
          </h2>

          <p className="text-gray-600 text-[16px] text-base leading-relaxed">
            Our support team is just a message away and ready to assist you with anything—fast, friendly, and reliable. Reach out to us anytime — our team will respond promptly to assist you.
          </p>

          <a
            href="https://www.lentera.in/why-us/" // Replace with your link
            className="inline-flex items-center gap-2 bg-[#07862B] hover:bg-green-800 transition text-white px-6 py-3 rounded-full font-semibold"
          >
            QUICK CONNECT
            <span className="text-xl">→</span>
          </a>

        </div>

        {/* Right Side - Seamless Scrolling Strip */}
        <div className="relative mt-10 md:mt-0 w-[494px] h-[380px] overflow-hidden">
          {/* Blur Overlays */}
          <div className="absolute top-0 left-0 w-16 h-full z-10 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none" />
          <div className="absolute top-0 right-0 w-16 h-full z-10 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none" />

          {/* Scrolling Wrapper */}
          <div className="flex w-max animate-scroll-seamless whitespace-nowrap">
            {/* Repeat image enough times to ensure seamless loop */}
            {[...Array(4)].map((_, i) => (
              <img
                key={i}
                src={contactStrip}
                alt={`contact-strip-${i}`}
                className="h-[380px] w-[494px] object-cover shrink-0"
              />
            ))}
          </div>

          {/* Custom Animation */}
          <style>{`
          @keyframes scroll-seamless {
            0% {
              transform: translateX(0%);
            }
            100% {
              transform: translateX(-50%);
            }
          }
          .animate-scroll-seamless {
            animation: scroll-seamless 20s linear infinite;
          }
        `}</style>
        </div>
      </div>
      <section className="bg-white pt-20 pb-0 w-full">
        {/* Section Header */}
        <div className="text-center px-4 sm:px-6 md:px-10 lg:px-20 mb-10 max-w-screen-xl mx-auto">
          <h2 className="text-4xl font-bold text-[#1c1c1c] mb-4">Our location</h2>
          <p className="text-lg text-[#3d3d3d]">
            Feel free to visit our office to learn more about our products, services, and work culture.
          </p>
        </div>

        {/* Full-Width Google Map */}
        <div className="w-full h-[500px] overflow-hidden">
          <iframe
            title="Lentera Technologies Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.0616475436946!2d80.2090835!3d12.9636427!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d628d45f3a7%3A0xb699ddbfaf9c98be!2sLentera%20Technologies%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1720000000000!5m2!1sen!2sin"
            className="w-full h-full border-0"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>

    </>
  );
}
